import ContactUs from "./ContactUs";
import Footer from "./Footer";
import Header from "./Header";

function Home() {

  return (
    <>
    <Header />
    <section className="container mx-auto scroll-smooth pl-10 pr-10">

      


      <section className="mx-auto px-4 py-12 grid md:grid-cols-2 gap-8 items-center">
        <div>
          <div className="space-y-1 text-lg text-gray-700 leading-relaxed">
            <h1 className="text-2xl md:text-5xl font-bold leading-tight">
              Simplify <span className="bg-white-500 text-[#00A6FB] pz-2">Member</span> and <br />
              <span className="bg-white-500 text-[#00A6FB] pz-2">Membership</span> management while unlocking growth with <span className="bg-white-500 text-[#003566] pz-2">member</span><span className="bg-white-500 text-[#00A6FB]">meld</span>
            </h1>

            <p className="text-gray-600 mt-6 text-lg">
              An all-in-one system for handling Member, Memberships, Attendance, Enquiries, Branches and Finance reporting — built for growing organizations.
            </p>
             <p className="text-gray-600 mt-6 text-lg">
              Whether you are running a Gym, Sports Academy, Coaching Centre, Club, or any service that tracks members, this app simplifies everything.
            </p>
            {/* App store buttons */}
            <div className="flex flex-col md:flex-row items-center gap-4 mt-8 mx-auto">
              <a
    href="https://play.google.com/store/apps/details?id=com.lats.membermeld"
    target="_blank"
    rel="noopener noreferrer"
  >
              <img src="/playstore.png" alt="Get it on Google Play" className="h-12" />
              </a>
              <a
    href="https://apps.apple.com/app/id6746827630" // replace with your App Store ID
    target="_blank"
    rel="noopener noreferrer">
              <img src="/apple_store.png" alt="Download on App Store" className="h-12" />
              </a>
            </div>
          </div>
        </div>
        <div className="mx-auto">
          <img src="/feature0.svg" alt="Membership Dashboard Preview" className="w-130 h-130 rounded-2xl shadow-xl" />
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-8 items-center">

        {/* Description - appear first on mobile, second on desktop */}
        <div className="order-1 md:order-2">
          <h2 className="text-2xl font-bold mb-6 text-[#003566]">
            Dashboard Highlights
          </h2>
          <div className="space-y-1 text-lg text-gray-700 leading-relaxed">
            <ul className="space-y-3">
              {/* List Items (unchanged) */}
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" stroke-linecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  Stay on top of finances with real-time totals for collections and expenses.
                </p>
              </li>
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" stroke-linecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  Get instant insights into today’s admissions, renewals, and collections.
                </p>
              </li>
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" stroke-linecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  Track members with upcoming expirations and birthdays effortlessly.
                </p>
              </li>
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" stroke-linecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  Tap any metric to explore full member lists in a smooth modal sheet.
                </p>
              </li>
            </ul>
          </div>
        </div>

        {/* Image - appear second on mobile, first on desktop */}
        <div className="flex-col order-2 md:order-1">
          <img src="/feature1.png" alt="Membership Dashboard Preview" className="w-70 h-130 rounded-2xl shadow-xl" />
        </div>

      </section>



      <section className="max-w-5xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-8 items-center">
        <div className="order-1 md:order-1">
          <h2 className="text-2xl font-bold mb-6 text-[#003566]">
            Transaction Highlights
          </h2>
          <div className="space-y-1 text-lg text-gray-700 leading-relaxed">
            <ul className="space-y-3">
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" strokeLinecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  Analyze your income and expenses effortlessly across multiple date ranges.
                </p>
              </li>
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" strokeLinecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  Quickly switch between Today, This Week, This Month, or Custom periods.
                </p>
              </li>
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" strokeLinecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  View real-time totals with beautiful pie charts for clear visual insights.
                </p>
              </li>
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" strokeLinecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  Separate tabs for Income and Expenses to keep your records organized.
                </p>
              </li>
            </ul>
          </div>
        </div>

        <div className="order-2 md:order-2 mx-auto">
          <img src="/feature2.png" alt="Membership Dashboard Preview" className="w-70 h-130 rounded-2xl shadow-xl" />
        </div>
      </section>




      <section className="max-w-5xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-8 items-center">

        {/* Description - appear first on mobile, second on desktop */}
        <div className="order-1 md:order-2">
          <h2 className="text-2xl font-bold mb-6 text-[#003566]">
            Member List Screen Highlights
          </h2>
          <div className="space-y-1 text-lg text-gray-700 leading-relaxed">
            <ul className="space-y-3">
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" stroke-linecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  Easily browse all members with photo, joining date, plan details, and mobile number.
                </p>
              </li>
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" stroke-linecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  Quickly spot membership status with color-coded labels for active, expired, and dues pending.
                </p>
              </li>
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" stroke-linecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  See days remaining for each member’s plan at a glance — never miss a renewal.
                </p>
              </li>
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" stroke-linecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  Celebrate member birthdays with an animated birthday wish button that pops with joy!
                </p>
              </li>

              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" stroke-linecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  Mark attendance instantly for each member directly from the list.
                </p>
              </li>
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" stroke-linecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  Powerful search by member name or mobile number for faster access.
                </p>
              </li>
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" stroke-linecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  Smart filters to view Active, Archived, Expiring Soon, Expired, and Due Pending members.
                </p>
              </li>
            </ul>
          </div>
        </div>

        {/* Image - appear second on mobile, first on desktop */}
        <div className="order-2 md:order-1">
          <img src="/feature3.png" alt="Membership Dashboard Preview" className="w-70 h-130 rounded-2xl shadow-xl" />
        </div>

      </section>


      <section className="max-w-5xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-8 items-center">
        <div className="order-1 md:order-1">
          <h2 className="text-2xl font-bold mb-6 text-[#003566]">
            Member Details Highlights
          </h2>
          <div className="space-y-1 text-lg text-gray-700 leading-relaxed">
            <ul className="space-y-3">
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" strokeLinecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  Displays member name, photo, and scannable QR code for Member ID.
                </p>
              </li>
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" strokeLinecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  Tracks payment and renewals history including plan types, amounts and discounts.
                </p>
              </li>
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" strokeLinecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  Send reminders for plan renewals and plan expiries.
                </p>
              </li>
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" strokeLinecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  Provides action buttons for renewals, pending dues, and edits.
                </p>
              </li>
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" strokeLinecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  Visualizes attendance history via calendar view.
                </p>
              </li>
              <li className="flex">
                <svg className="h-[1lh] w-5.5 shrink-0" viewBox="0 0 22 22" fill="none" strokeLinecap="square">
                  <circle cx="11" cy="11" r="11" className="fill-white" />
                  <circle cx="11" cy="11" r="10.5" className="stroke-[#00A6FB]" />
                  <path d="M8 11.5L10.5 14L14 8" className="stroke-[#00A6FB] dark:stroke-[#00A6FB]" />
                </svg>
                <p className="ml-3">
                  Easily archive inactive members to keep your active list organized while preserving their data for future reference.
                </p>
              </li>
            </ul>
          </div>
        </div>

        <div className="order-2 md:order-2 mx-auto">
          <img src="/feature4.png" alt="Membership Dashboard Preview" className="w-70 h-130 rounded-2xl shadow-xl" />
        </div>
      </section>
      
      <ContactUs></ContactUs>
      {/* App store buttons */}
      <div className="flex justify-center mt-8 mb-20">
        <div className="flex flex-col md:flex-row items-center gap-4">
           <a
    href="https://play.google.com/store/apps/details?id=com.lats.membermeld"
    target="_blank"
    rel="noopener noreferrer"
  >
          <img src="/playstore.png" alt="Get it on Google Play" className="h-12" />
          </a>
          <a
    href="https://apps.apple.com/app/id6746827630" // replace with your App Store ID
    target="_blank"
    rel="noopener noreferrer">
          <img src="/apple_store.png" alt="Download on App Store" className="h-12" />
          </a>
        </div>
      </div>
      
    </section>
    <Footer />
</>
  );
};

export default Home;